/**
 * SongReviewCard Component
 *
 * Displays a flashcard with Spanish front and English back.
 * Shows spaced repetition metadata (ease factor, interval, repetitions).
 * Provides click-to-flip interaction.
 */

interface Flashcard {
  _id: string
  frontSpanish: string[]
  backEnglish: string[]
  easeFactor: number
  interval: number
  repetitions: number
}

interface SongReviewCardProps {
  flashcard: Flashcard
  isFlipped: boolean
  onFlip: () => void
}

export function SongReviewCard({ flashcard, isFlipped, onFlip }: SongReviewCardProps) {
  return (
    <div
      className="mb-6 terminal-border border-terminal-green p-8 min-h-[300px] flex items-center justify-center cursor-pointer hover:bg-terminal-green/5 transition-colors shadow-[0_2px_8px_rgba(255,255,255,0.4)]"
      onClick={onFlip}
    >
      <div className="text-center">
        {!isFlipped ? (
          <>
            <div className="text-sm text-sky-blue font-mono mb-2">[SPANISH]</div>
            <div className="text-3xl text-terminal-green font-mono font-bold">
              {flashcard.frontSpanish.join(' ')}
            </div>
            <div className="mt-4 text-trail-tan font-mono text-sm">
              Click to reveal English
            </div>
          </>
        ) : (
          <>
            <div className="text-sm text-sky-blue font-mono mb-2">[ENGLISH]</div>
            <div className="text-2xl text-trail-tan font-mono">
              {flashcard.backEnglish.join(' ')}
            </div>
            <div className="mt-6 text-terminal-green font-mono text-sm">
              <div>Ease: {flashcard.easeFactor.toFixed(2)}</div>
              <div>Interval: {flashcard.interval} days</div>
              <div>Repetitions: {flashcard.repetitions}</div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
